import { useContext } from 'react';
import { SelectedParticipantContext } from 'context';

export function useSelectedParticipant() {
  const [selectedParticipant, setSelectedParticipant] = useContext(SelectedParticipantContext)!;
  return [selectedParticipant, setSelectedParticipant] as const;
}
